export default "__VITE_ASSET__CIP5b9gk__"